import { createAsyncThunk, createSlice,combineReducers } from "@reduxjs/toolkit";
import { BASE_URL } from "../config";
import { AllBookingLists, Answers, BookingLists, IAnswerQuestion } from "../interfaces/BookingList";
import axios from "axios";


interface ParsedData {
  accessToken?: string;
}

interface BookingState {
  loading: boolean;
  user: any | null;
  error: string | null;
  isLoggedIn: boolean;
  data: BookingLists[] | null;
  data1: Answers[] | null;
}


const initialState: BookingState = {
  loading: false,
  user: null,
  error: null,
  isLoggedIn: false,
  data: null,
  data1: null,
};

export const BookingList = createAsyncThunk(
  "booking/BookingList",
  async (_, thunkAPI) => {
    try {
      const responseData = localStorage.getItem("loginData");

      if (!responseData) {
        console.error("Response data is null.");
        return thunkAPI.rejectWithValue("Response data is null.");
      }

      const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;

      if (!accessToken) {
        console.error("Access token not found in the response.");
        return thunkAPI.rejectWithValue("Access token not found in the response.");
      }
      
      const response = await fetch(`${BASE_URL}/api/v1/bookings`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      });

       if (!response.ok) {
         return thunkAPI.rejectWithValue(`HTTP error! Status: ${response.status}`);
       }

      const result = await response.json();      
      return result.data.userBookings;
      
    } catch (error: any) {
      console.error("Error fetching User Details:", error.message);
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);


export const BookingDetails = createAsyncThunk(
  "booking/BookingDetails",
  async (bookingId: string, thunkAPI) => {
    try {
      const responseData = localStorage.getItem("loginData");

      if (!responseData) {
        console.error("Response data is null.");
        return thunkAPI.rejectWithValue("Response data is null.");
      }

      const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;

      if (!accessToken) {
        console.error("Access token not found in the response.");
        return thunkAPI.rejectWithValue("Access token not found in the response.");
      }
      
      const response = await fetch(`${BASE_URL}/api/v1/patients/userBookingDetails/${bookingId}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      });

       if (!response.ok) {
         return thunkAPI.rejectWithValue(`HTTP error! Status: ${response.status}`);
       }

      const result = await response.json();    
      
      return result.data;
      
    } catch (error: any) {
      console.error("Error fetching User Details:", error.message);
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);


export const BookQuestion = createAsyncThunk(
  "booking/BookQuestion",
  async ({ answers, programId}: IAnswerQuestion, thunkAPI) => { 
    console.log(programId);
    try {
      const responseData = localStorage.getItem("loginData");

      if (!responseData) {
        console.error("Response data is null.");
        return thunkAPI.rejectWithValue("Response data is null.");
      }

      const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;

      if (!accessToken) {
        console.error("Access token not found in the response.");
        return thunkAPI.rejectWithValue("Access token not found in the response.");
      }

      const response = await axios({
        method: "POST",
        url: `${BASE_URL}/api/v1/patients/answers`,
        data: JSON.stringify({programId:programId, questions: answers }),
        headers: {
          'Content-Type': "application/json",
          Authorization: `Bearer ${accessToken}`,
          // Add other headers if needed
        },
      });

      const result = await response;
      return result.data; // Update this based on the structure of your response
    } catch (error: any) {
      console.error("Error updating Slot:", error.message);
      return thunkAPI.rejectWithValue(`Update failed: ${error.message}`);
    }
  }
);

export const BookAnsweredData = createAsyncThunk(
  "booking/BookAnsweredData",
  async (pid: string, thunkAPI) => {
    
    try {
      
      const responseData = localStorage.getItem("loginData");

      if (!responseData) {
        console.error("Response data is null.");
        return thunkAPI.rejectWithValue("Response data is null.");
      }

      const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;

      if (!accessToken) {
        console.error("Access token not found in the response.");
        return thunkAPI.rejectWithValue("Access token not found in the response.");
      }

      const response = await axios({
        method: "GET",
        url: `${BASE_URL}/api/v1/patients/answers/${pid}`,       
        headers: {
          Authorization: `Bearer ${accessToken}`,
          // Add other headers if needed
        },
      });

      const result = await response;
      
      return result.data.data.answers; // Update this based on the structure of your response

    } catch (error: any) {
      console.error("Error updating Slot:", error.message);
      return thunkAPI.rejectWithValue(`Update failed: ${error.message}`);
    }
  }
);


export const BookSlot = createAsyncThunk(
  "booking/BookSlot",
  async (bookslots: any, thunkAPI) => {
    try {
      const responseData = localStorage.getItem("loginData");

      if (!responseData) {
        console.error("Response data is null.");
        return thunkAPI.rejectWithValue("Response data is null.");
      }

      const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;

      if (!accessToken) {
        console.error("Access token not found in the response.");
        return thunkAPI.rejectWithValue("Access token not found in the response.");
      }

       const response = await axios({
      method :"POST",
      url: `${BASE_URL}/api/v1/patients/counsellings/book`,
      data: JSON.stringify({ id: bookslots }),
      headers: {
        'Content-Type': "application/json",
        Authorization: `Bearer ${accessToken}`,
        // Add other headers if needed
      },
    });
    
          // if (!response.ok) {
      //   return thunkAPI.rejectWithValue(`HTTP error! Status: ${response.status}`);
      // }

      const result = await response;
     return result.data; // Update this based on the structure of your response
    } catch (error: any) {
      console.error("Error updating Slot:", error.message);
      return thunkAPI.rejectWithValue(`Update failed: ${error.message}`);
    }
  }
);


export const AllBookingList = createAsyncThunk(
  "booking/AllBookingList",
  async (_, thunkAPI) => {
    try {
      const responseData = localStorage.getItem("loginData");

      if (!responseData) {
        console.error("Response data is null.");
        return thunkAPI.rejectWithValue("Response data is null.");
      }

      const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;

      if (!accessToken) {
        console.error("Access token not found in the response.");
        return thunkAPI.rejectWithValue("Access token not found in the response.");
      }
      
      const response = await fetch(`${BASE_URL}/api/v1/bookings/all`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      });

       if (!response.ok) {
         return thunkAPI.rejectWithValue(`HTTP error! Status: ${response.status}`);
       }

      const result = await response.json();      
      return result.data.bookings;
      
    } catch (error: any) {
      console.error("Error fetching User Details:", error.message);
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);


const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(BookingList.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(BookingList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; 
      })
      .addCase(BookingList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error:", action.payload); // Log the detailed error
      })
      .addCase(BookingDetails.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(BookingDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; 
      })
      .addCase(BookingDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error:", action.payload); // Log the detailed error
      })
      .addCase(AllBookingList.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(AllBookingList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; 
      })
      .addCase(AllBookingList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error:", action.payload); // Log the detailed error
      })
      .addCase(BookSlot.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(BookSlot.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; 
      })
      .addCase(BookSlot.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error:", action.payload); // Log the detailed error
      }) .addCase(BookAnsweredData.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(BookAnsweredData.fulfilled, (state, action) => {
        state.loading = false;
        state.data1 = action.payload; 
      })
      .addCase(BookAnsweredData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error:", action.payload); // Log the detailed error
      });
      
  },
});

export const { resetState } = bookingSlice.actions;
export default bookingSlice.reducer;
